
type Props = {}

const SetUpFour = (props: Props) => {
  return (
    <div>SetUpFour</div>
  )
}

export default SetUpFour